import MyLocations from "./features/MyLocations/MyLocations";
import MyServices from "./features/MyServices/MyServices";
import MyRequests from "./features/MyRequests/MyRequests";
import AddService from "./features/MyServices/SubComponents/AddService/AddService";
import { UsersList } from "./Components/UserDetails/Users";
import { UserDetails } from "./Components/UserDetails/UserDetails";
import { Fields } from "./Components/Fields";
import AddDronePilot from "./features/DronePilots/SubComponents/AddDronePilot";
import DronePilots from "./features/DronePilots/DronePilots";
import ManageTeam from "./features/Operators/ManageTeam";
import MyDrones from "./features/MyDrones/MyDrones";
import ViewRequest from "./features/MyRequests/SubComponents/ViewRequest/ViewRequest";
import AdminDashBoard from "./AdminComponents/AdminDashBoard/AdminDashBoard";
import DroneServiceProvider from "./AdminComponents/DroneServiceProviders/DroneServiceProviders";
import Users from "./AdminComponents/Users/Users";
import Requests from "./AdminComponents/Requests/Requests";
import Locations from "./AdminComponents/Locations/Locations";
import Revenue from "./features/Revenue/Revenue";
import Manufacturers from "./AdminComponents/Manufacturers/Manufacturers";
import RequestDetails from "./features/MyRequests/RequestDetails";
import Crops from "./AdminComponents/Crops/Crops";
import AdminCoupons from "./AdminComponents/Coupons/AdminCoupons";
import ViewLocationsOnMap from "./AdminComponents/Locations/ViewLocationsOnMap";
import AllCoupons from "./features/Coupon/AllCoupons";
import CreateRequest from "./features/MyRequests/CreateRequest";
import MyWallet from "./features/Wallet/MyWallet";
import SupportEmails from "./AdminComponents/SupportEmails/SupportEmails";
import PaymentInvoice from "./AdminComponents/Finance/subComponents/PaymentInvoice.js";
import DspInvoiceDetails from "./features/Invoices/DspInvoiceDetails";
import ManageAdminTeam from "./AdminComponents/Teams/ManageAdminTeam";
import FinanceDashboard from "./BhuMeetTeams/BhuMeetFinance/FinanceDashboard";
import CustSuccessDashboard from "./BhuMeetTeams/BhuMeetCustomerSuccess/CustSuccessDashboard";
import Profile from "./features/Profile/Profile";
import HomePage from "./features/HomePage/HomePage";
import OperationsDashboard from "./BhuMeetTeams/Operations/OperationsDashboard";
import DspWallet from "./AdminComponents/Finance/wallets/DspWallet.js";
import DspInvoices from "./AdminComponents/Finance/DSPInvoices/index.js";
import UserInvoices from "./AdminComponents/Finance/UserInvoices/UserInvoices.js";
import UserInvoiceDetails from "./AdminComponents/Finance/UserInvoices/UserInvoiceDetails.js";
import RevenueDashboard from "./BhuMeetTeams/BhuMeetFinance/RevenueDashboard.js";
import ViewUserDetails from "./AdminComponents/Users/SubComponents/ViewUserDetails.js";
import ViewRequestDetails from "./AdminComponents/Requests/SubComponents/ViewRequestDetails.js";
import Drones from "./BhuMeetTeams/BhuMeetCustomerSuccess/Drones.js";
import FinanceDsps from "./BhuMeetTeams/BhuMeetFinance/FinanceDsps.js";
import OperationsDsps from "./BhuMeetTeams/Operations/OperationsDsps.js";
import CustSuccessdsps from "./BhuMeetTeams/BhuMeetCustomerSuccess/CustSuccessDsps.js";
import OperationsUsers from "./BhuMeetTeams/Operations/OperationsUsers.js";
import ViewUsersOnLocation from "./BhuMeetTeams/Operations/ViewUsersOnMaps.js";
import DspDetails from "./BhuMeetTeams/Operations/DspDetails.js";
import MarketingDashBoard from "./BhuMeetTeams/Marketing/MarketingDashBoard.js";
import SendNotifications from "./BhuMeetTeams/Marketing/SendNotifications.js";
import OperationsPilots from "./BhuMeetTeams/Operations/OperationsPilots.js";
import RewardProgram from "./BhuMeetTeams/Operations/RewardProgram.js";
import CussRewardProgram from "./BhuMeetTeams/BhuMeetCustomerSuccess/RewardProgram.js";
import RewardOrders from "./BhuMeetTeams/Operations/RewardOrders.js";
import CustomerSuccessDspDashboard from "./BhuMeetTeams/BhuMeetCustomerSuccess/CustomerSuccessDspDashboard.js";
import FinanceDspDetailsDashboard from "./BhuMeetTeams/BhuMeetFinance/FinanceDspDetailsDashboard.js";
import Orders from "./BhuMeetTeams/BhuMeetFinance/Orders/Orders.js";
import Stores from "./BhuMeetTeams/Operations/Stores.js";
import StoresDetailsDashBoard from "./BhuMeetTeams/Operations/StoresDetailsDashBoard.js";
import OperationsViewRequest from "./BhuMeetTeams/Operations/OperationsViewRequest.js";
import OperationsRequests from "./BhuMeetTeams/Operations/OperationsRequests.js";
import RewardProducts from "./BhuMeetTeams/Operations/RewardProducts.js";
import DroneStoreDashboard from "./BhuMeetTeams/Operations/DroneStoreDashboard.js";
import DroneManufactures from "./BhuMeetTeams/Operations/droneStore/manufactures.js";
import DroneModels from "./BhuMeetTeams/Operations/droneStore/manufacturedetail.js";
import DroneEnquiries from "./BhuMeetTeams/Operations/droneStore/droneEnquiry.js";
import SalesDashboard from "./BhuMeetTeams/BhuMeetSales/SalesDashboard.js";
import SalesStoreDetails from "./BhuMeetTeams/BhuMeetSales/Stores/SalesStoreDetails.js";
import SalesStores from "./BhuMeetTeams/BhuMeetSales/Stores/SalesStores.js";
import AddDroneModel from "./BhuMeetTeams/Operations/droneStore/AddDroneModel.js";
import { TeleCallerDashBoard } from "./BhuMeetTeams/BhumeetTeleCaller/TeleCallerDashboard.js";
import DspDebitNotes from "./BhuMeetTeams/BhuMeetFinance/DspDebitNotes.js";
import BesIncentiveInvoice from "./BhuMeetTeams/BhuMeetCustomerSuccess/BesIncentiveInvoices.js";
import BesFinanceIncentiveInvoice from "./BhuMeetTeams/BhuMeetFinance/BesIncentiveInvoice.js";
import FinanceBesDashBoard from "./BhuMeetTeams/BhuMeetFinance/FinanceBesDashBoard.js";
import BesFinanceStores from "./BhuMeetTeams/BhuMeetFinance/Stores/BesFinanceStores.js";
import StoreDetailsDashBoard from "./BhuMeetTeams/BhuMeetFinance/Stores/StoreDashBoard.js";
import Feeds from "./AdminComponents/Feeds/Feeds.js";
import CreateNewFeed from "./AdminComponents/Feeds/CreateNewFeed.js";
import ViewPost from "./AdminComponents/Feeds/ViewPost.js";
import { RequestIssueDashboard } from "./BhuMeetTeams/Operations/RequestIssue/issueDashboard.js";
import { RequestIssueDetail } from "./BhuMeetTeams/Operations/RequestIssue/viewRequestIssueDetail.js";
import BhuMeetPerformance from "./BhuMeetTeams/Operations/BhuMeetPerformance/index.js";
import { MarketingNotificationHistory } from "./BhuMeetTeams/Marketing/NotificationHistory.js";
import MarketingStatsDashBoard from "./BhuMeetTeams/Marketing/MarketingStatsDashboard.js";
import { MarketingTextNotificationHistory } from "./BhuMeetTeams/Marketing/TextNotificationHistory.js";
import CrmDashBoard from "./BhuMeetTeams/CRM/crmDashboard.js";
import { AllLeads } from "./BhuMeetTeams/CRM/allLeads.js";
import { LeadsDetail } from "./BhuMeetTeams/CRM/leadDetails.js";
import { AllLeadsCallHistory } from "./BhuMeetTeams/CRM/allLeadsCallHistory.js";
import RequestsOverView from "./Components/RequestsOverView/RequestsOverView.js";
import BesRequestsOverView from "./Components/BesRequestsOverView/BesRequestsOverView.js";
import { AllCampaign } from "./BhuMeetTeams/BhuMeetSales/Campaign/allCampaign.js";
import { TeleCallerSalesDashBoard } from "./BhuMeetTeams/TelecallerSales/dashboard.js";
import IncentiveOverView from "./Components/IncentivesOverView/IncentiveOverView.js";
import DspIncentives from "./features/Incentive/subcomponents/DspIncentives.js";
import LeadInvoices from "./AdminComponents/Finance/LeadInvoices/LeadInvoices.js";
import DspLeadInvoiceDetails from "./AdminComponents/Finance/subComponents/DspLeadInvoiceDetails.js";
import SubscriptionPlans from "./features/Subscription/SubscriptionPlans.js";
import DSPSubscriptionInvoices from "./AdminComponents/Finance/SubscriptionInvoices/SubscriptionInvoices.js";
import SubscriptionInvoiceDetails from "./AdminComponents/Finance/SubscriptionInvoices/SubscriptionInvoiceDetails.js";
import DspSubscriptionInvoiceDetails from "./AdminComponents/Finance/subComponents/DspSubscriptionInvoiceDetails.js";
import OperationsLeadOrders from "./BhuMeetTeams/Operations/OperationsLeadOrdersDetails.js";
import OperationsLeadOrdersDetails from "./BhuMeetTeams/Operations/OperationsLeadOrdersDetails.js";
import Reports from "./features/Reports/Reports.js";
import PilotsPerformanceReport from "./features/Reports/PilotsPerformanceReport.js";
import OrderPerformanceReport from "./features/Reports/OrderPerformanceReport.js";
import Acreage from "./features/Acreage/Acreage.js";
const ROUTES = {
  PROFILE: "/profile",
  MYSERVICES: "/manageServices",
  MYLOCATIONS: "/manageLocations",
  MYREQUESTS: "/manageRequests",
  REQUESTDETAILS: "/requestDetails",
  ADD_SERVICE: "/service",
  CUSTOMERS: "/customers",
  CUSTOMER_DETAILS: "/customer",
  CUSTOMER_FIELDS: "/customer/:userId/fields",
  ADD_DRONE_PILOT: "/addDronePilot",
  DRONE_PILOTS: "/dronePilots",
  MANAGE_TEAM: "/manageTeams",
  MYDRONE: "/manageDrones",
  VIEWREQUEST: "/viewRequest",
  REVENUE: "/revenue",
  ACREAGE: "/acreage",
  MYREVENUE: "/revenue",
  COUPON: "/coupons",
  CREATEREQUEST: "/createRequest",
  WALLET: "/wallet",
  REQUESTSOVERVIEW: "/requestsOverview",
  INCENTIVESOVERVIEW: "/incentivesOverview",
  // INCENTIVES:'/incentives',
  BESREQUESTSOVERVIEW: "/besRequestsOverview",
  PAYMENTINVOICE: "/paymentInvoice",
  LEADINVOICEDETAILS: "/leadInvoiceDetails",
  SUBSCRIPTION_PLANS: "/plan-purchase",
  SUBSCRIPTION_INVOICE_DETAILS: "/subscriptionInvoiceDetails",
  REPORTS: "/reports",
  PILOTS_PERFORMANCE_REPORT: "/reports/pilots-performance",
  ORDERS: "/orders",
  ORDERS_PERFORMANCE_REPORT: "/reports/orders-performance",
};

const PDRL_FINANCE_ROUTES = {
  FINANCE_DASHBOARD: "/bhumeet_team/finance/dashboard",
  DSP_INVOICES: "/bhumeet_team/finance/dsp/invoices",
  USER_INVOICES: "/bhumeet_team/finance/user/invoices",
  USER_INVOICE_DETAILS: "/bhumeet_team/finance/user/invoiceDetails",
  REVENUE_DASHBOARD: "/bhumeet_team/finance/revenueDashboard",
  PAYMENTINVOICE: "/paymentInvoice",
  FINANCEDSPS: "/bhumeet_team/finance/droneServiceProviders",
  FINANCEDSPDASHBOARD: "/bhumeet_team/finance/dsp",
  ORDERS: "/bhumeet_team/finance/orders",
  REQUESTDETAILS: "/bhumeet_team/finance/requestDetails",
  DSP_DEBIT_NOTES: "/bhumeet_team/finance/debit/notes",
  FINANCEBESINVOICES: "/bhumeet_team/finance/bes/invoices",
  INCENTIVEINVOICE: "/finance/incentive/invoice",
  FINANCESTORES: "/bhumeet_team/finance/stores",
  STORESDETAILSDASHBOARD: "/bhumeet_team/finance/store/details",
  LEAD_INVOICES: "/bhumeet_team/finance/dsp/leadinvoices",
  SUBSCRIPTION_INVOICES: "/bhumeet_team/finance/dsp/subscriptioninvoices",
  LEAD_INVOICE_DETAILS: "/bhumeet_team/finance/dsp/lead/invoice/details",
  SUBSCRIPTION_INVOICE_DETAILS:
    "/bhumeet_team/finance/dsp/subscription/invoice/details",
};

const PDRL_SALES_ROUTES = {
  SALES_DASHBOARD: "/bhumeet_team/sales/dashboard",
  SALES_STORES: "/bhumeet_team/sales/stores",
  SALES_STORES_DETAILS: "/bhumeet_team/sales/details",
  CRMDASHBOARD: "/crm",
  CRMLEADS: "/crm/leads",
  CRMLEAD_DETAIL: "/crm/leads/detail",
  CRMLEAD_LOGS: "/crm/leadslog",
  CRMCAMPAIGN: "/crm/campaign",
};

const PDRL_SUCCESS_ENGI_ROUTES = {
  SUCCESS_ENGI_DASHBOARD: "/bhumeet_team/cse/dashboard",
  DRONE_SERVICE_PROVIDERS: "/bhumeet_team/cse/droneServiceProviders",
  USERS: "/cse/users",
  USERDETAILS: "/userDetails",
  OPERATIONSUSERS: "/operations/users",
  CSEUSERDETAILS: "/cse/userDetails",
  REQUESTS: "/requests",
  LEAD_ORDERS: "/leadOrders",
  OPERATIONS_REQUESTS: "/operations/requests",
  REQUESTDETAILS: "/requestDetails",
  OPERATIONS_REQUESTDETAILS: "/operations/requestDetails",
  CUSTOMERSUCESSDSPDASHBOARD: "/cse/dsps/viewdsp",
  CustStore: "/bhumeet_team/cse/store",
  CUSTSTOREDETAILS: "/bhumeet_team/cse/store/details",
  success_REWARDPROGRAM: "/bhumeet_team/cse/reward/program",
  success_REWARDORDERS: "/bhumeet_team/cse/reward/orders",
  INCENTIVEINVOICE: "/ces/incentive/invoice",
  REQUESTISSUEDASHBOARD: "/issue/dashboard",
  REQUESTISSUEDETAIL: "/issue/requestIssueDetail",
  CRMDASHBOARD: "/crm",
  CRMLEADS: "/crm/leads",
  CRMLEAD_DETAIL: "/crm/leads/detail",
  CRMLEAD_LOGS: "/crm/leadslog",
  LEAD_DETAILS: "/lead/details",
};

const PDRL_MARKETING_ROUTES = {
  MARKETINGDASHBOARD: "/marketing",
  NOTIFICATIONS: "/notifications",
  FEEDS: "/feeds",
  NEWFEED: "/feeds/new",
  VIEWPOST: "/view/post",
  CRMDASHBOARD: "/crm",
  CRMLEADS: "/crm/leads",
  CRMLEAD_DETAIL: "/crm/leads/detail",
  CRMLEAD_LOGS: "/crm/leadslog",
};

const PDRL_Telecaller_ROUTES = {
  TelecallerDashboard: "/telecallerdashboard",
};

const PDRL_TELECALLER_SALES_ROUTES = {
  TeleCallerSalesDashBoard: "/telecallersalesdashboard",
  CRMLEAD_DETAIL: "/crm/leads/detail",
};

const PDRL_ADMIN_ROUTES = {
  ADMIN_DASHBOARD: "/adminDashboard",
  LOCATIONS: "/locations",
  MANUFACTURES: "/manufacturers",
  CROPS: "/crops",
  COUPONS: "/adminCoupons",
  VIEWLOCATIONSONMAP: "/locations/map",
  SUPPORTEMAILS: "/supportEmails",
  DSPWALLET: "/dspWallet",
  TEAMS: "/teams",
  OPEARTIONSDASHBOARD: "/operations",
  ALLDRONES: "/allDrones",
  OPERATIONDSPS: "/droneServiceProviders",
  OPERATIONSUSERS: "/operations/users",
  OPEARTIONSPILOTS: "/operations/pilots",
  VIEWUSERSONMAP: "/operations/users/map",
  DSPDASHBOARD: "/operations/dsps/viewdsp",
  REWARDPROGRAM: "/operations/reward/program",
  REWARDORDERS: "/operations/reward/orders",
  DRONESTORE: "/operations/droneDashboard",
  DRONEENQUIRY: "/operations/droneinquiry",
  DRONESTOREMANUFACTURE: "/operations/droneDashboard/manufacture",
  DRONEMODELS: "/operations/droneDashboard/manufacture/dronemodels",
  DRONEMODELDETAIL: "/operations/droneDashboard/manufacture/dronemodels/drone",
  REWARD_PRODUCTS: "/bhumeet_team/operations/reward/products",
  STORES: "/reward/stores",
  STOREDETAILS: "/reward/store/details",
  CREATEFEED: "/feeds/new",
  VIEWPOST: "/view/post",
  REQUESTISSUEDASHBOARD: "/issue/dashboard",
  REQUESTISSUEDETAIL: "/issue/requestIssueDetail",
  BHUMEET_PERFORMANCE: "/operations/bhumeetPerformance",
  MARKETINGNOTIFICATIONHISTORY: "/operations/marketingStats/notificatioHistory",
  MARKETINGSTATDASHBOARD: "/operations/marketingStats",
  TEXTNOTIFICATIONHISTORY: "/operations/marketingStats/textNotificationHistory",
  CRMDASHBOARD: "/crm",
  CRMLEADS: "/crm/leads",
  CRMLEAD_DETAIL: "/crm/leads/detail",
  CRMLEAD_LOGS: "/crm/leadslog",
  OPERATIONS_LEAD_DETAILS: "/operations/lead/details",
  TELECALLERORDERDETAILS: "/crm/order/details",
  ...PDRL_MARKETING_ROUTES,
  ...PDRL_FINANCE_ROUTES,
  ...PDRL_SUCCESS_ENGI_ROUTES,
  ...PDRL_SALES_ROUTES,
  ...PDRL_Telecaller_ROUTES,
  ...PDRL_TELECALLER_SALES_ROUTES,
};

const PDRL_TELECALLER_SALES_COMPONENTS = [
  {
    path: PDRL_TELECALLER_SALES_ROUTES.TeleCallerSalesDashBoard,
    element: <TeleCallerSalesDashBoard />,
  },
  {
    path: PDRL_TELECALLER_SALES_ROUTES.CRMLEAD_DETAIL,
    element: <LeadsDetail />,
  },
  {
    path: ROUTES.PROFILE,
    element: <Profile />,
  },
  {
    path: PDRL_SUCCESS_ENGI_ROUTES.USERDETAILS,
    element: <ViewUserDetails />,
  },
  {
    path: PDRL_SUCCESS_ENGI_ROUTES.REQUESTDETAILS,
    element: <ViewRequestDetails />,
  },
  {
    path: PDRL_ADMIN_ROUTES.TELECALLERORDERDETAILS,
    element: <OperationsLeadOrdersDetails />,
  },
];

const PDRL_FINANCE_COMPONENTS = [
  {
    path: PDRL_FINANCE_ROUTES.FINANCE_DASHBOARD,
    element: <FinanceDashboard />,
  },
  {
    path: PDRL_FINANCE_ROUTES.DSP_INVOICES,
    element: <DspInvoices />,
  },
  {
    path: PDRL_FINANCE_ROUTES.USER_INVOICES,
    element: <UserInvoices />,
  },
  {
    path: PDRL_FINANCE_ROUTES.USER_INVOICE_DETAILS,
    element: <UserInvoiceDetails />,
  },
  {
    path: PDRL_FINANCE_ROUTES.REVENUE_DASHBOARD,
    element: <RevenueDashboard />,
  },
  {
    path: PDRL_FINANCE_ROUTES.PAYMENTINVOICE,
    element: <PaymentInvoice />,
  },
  {
    path: PDRL_FINANCE_ROUTES.FINANCEDSPS,
    element: <FinanceDsps />,
  },
  {
    path: PDRL_FINANCE_ROUTES.FINANCEDSPDASHBOARD,
    element: <FinanceDspDetailsDashboard />,
  },
  {
    path: PDRL_FINANCE_ROUTES.ORDERS,
    element: <Orders />,
  },
  {
    path: PDRL_FINANCE_ROUTES.REQUESTDETAILS,
    element: <ViewRequestDetails />,
  },
  {
    path: PDRL_FINANCE_ROUTES.DSP_DEBIT_NOTES,
    element: <DspDebitNotes />,
  },
  {
    path: PDRL_FINANCE_ROUTES.FINANCEBESINVOICES,
    element: <FinanceBesDashBoard />,
  },
  {
    path: PDRL_FINANCE_ROUTES.INCENTIVEINVOICE,
    element: <BesFinanceIncentiveInvoice />,
  },
  {
    path: PDRL_FINANCE_ROUTES.FINANCESTORES,
    element: <BesFinanceStores />,
  },
  {
    path: PDRL_FINANCE_ROUTES.STORESDETAILSDASHBOARD,
    element: <StoreDetailsDashBoard />,
  },
  {
    path: PDRL_FINANCE_ROUTES.LEAD_INVOICES,
    element: <LeadInvoices />,
  },
  {
    path: PDRL_FINANCE_ROUTES.SUBSCRIPTION_INVOICES,
    element: <DSPSubscriptionInvoices />,
  },
  {
    path: PDRL_FINANCE_ROUTES.LEAD_INVOICE_DETAILS,
    element: <DspLeadInvoiceDetails />,
  },
  {
    path: PDRL_FINANCE_ROUTES.SUBSCRIPTION_INVOICE_DETAILS,
    element: <SubscriptionInvoiceDetails />,
  },
];

const PDRL_SUCCESS_ENGI_COMPONENTS = [
  {
    path: PDRL_SUCCESS_ENGI_ROUTES.SUCCESS_ENGI_DASHBOARD,
    element: <CustSuccessDashboard />,
  },
  {
    path: PDRL_SUCCESS_ENGI_ROUTES.DRONE_SERVICE_PROVIDERS,
    element: <CustSuccessdsps />,
  },
  {
    path: PDRL_SUCCESS_ENGI_ROUTES.success_REWARDPROGRAM,
    element: <CussRewardProgram />,
  },
  {
    path: PDRL_SUCCESS_ENGI_ROUTES.success_REWARDORDERS,
    element: <RewardOrders />,
  },
  {
    path: PDRL_ADMIN_ROUTES.OPERATIONSUSERS,
    element: <Users />,
  },
  {
    path: PDRL_ADMIN_ROUTES.USERS,
    element: <Users />,
  },
  {
    path: PDRL_ADMIN_ROUTES.REQUESTS,
    element: <Requests />,
  },
  {
    path: PDRL_ADMIN_ROUTES.OPERATIONS_REQUESTS,
    element: <OperationsRequests />,
  },
  {
    path: PDRL_SUCCESS_ENGI_ROUTES.USERDETAILS,
    element: <ViewUserDetails />,
  },
  {
    path: PDRL_SUCCESS_ENGI_ROUTES.CSEUSERDETAILS,
    element: <ViewUserDetails />,
  },
  {
    path: PDRL_SUCCESS_ENGI_ROUTES.OPERATIONS_REQUESTDETAILS,
    element: <OperationsViewRequest />,
  },
  {
    path: PDRL_SUCCESS_ENGI_ROUTES.REQUESTDETAILS,
    element: <ViewRequestDetails />,
  },
  {
    path: PDRL_SUCCESS_ENGI_ROUTES.CUSTOMERSUCESSDSPDASHBOARD,
    element: <CustomerSuccessDspDashboard />,
  },
  {
    path: PDRL_SUCCESS_ENGI_ROUTES.CustStore,
    element: <Stores />,
  },
  {
    path: PDRL_SUCCESS_ENGI_ROUTES.CUSTSTOREDETAILS,
    element: <StoresDetailsDashBoard />,
  },
  {
    path: PDRL_SUCCESS_ENGI_ROUTES.INCENTIVEINVOICE,
    element: <BesIncentiveInvoice />,
  },
  {
    path: PDRL_SUCCESS_ENGI_ROUTES.REQUESTISSUEDETAIL,
    element: <RequestIssueDetail />,
  },
  {
    path: PDRL_SUCCESS_ENGI_ROUTES.REQUESTISSUEDASHBOARD,
    element: <RequestIssueDashboard />,
  },
  {
    path: PDRL_ADMIN_ROUTES.CRMDASHBOARD,
    element: <CrmDashBoard />,
  },
  {
    path: PDRL_ADMIN_ROUTES.CRMLEADS,
    element: <AllLeads />,
  },
  {
    path: PDRL_ADMIN_ROUTES.CRMLEAD_DETAIL,
    element: <LeadsDetail />,
  },
  {
    path: PDRL_ADMIN_ROUTES.CRMLEAD_LOGS,
    element: <AllLeadsCallHistory />,
  },
  {
    path: PDRL_ADMIN_ROUTES.LEAD_DETAILS,
    element: <OperationsLeadOrdersDetails />,
  },
];

const PDRL_MARKETING_COMPONENTS = [
  {
    path: PDRL_MARKETING_ROUTES.MARKETINGDASHBOARD,
    element: <MarketingDashBoard />,
  },
  {
    path: PDRL_MARKETING_ROUTES.NOTIFICATIONS,
    element: <SendNotifications />,
  },
  {
    path: PDRL_MARKETING_ROUTES.FEEDS,
    element: <Feeds />,
  },
  {
    path: PDRL_MARKETING_ROUTES.VIEWPOST,
    element: <ViewPost />,
  },
  {
    path: PDRL_MARKETING_ROUTES.NEWFEED,
    element: <CreateNewFeed />,
  },
  {
    path: PDRL_MARKETING_ROUTES.CRMDASHBOARD,
    element: <CrmDashBoard />,
  },
  {
    path: PDRL_MARKETING_ROUTES.CRMLEADS,
    element: <AllLeads />,
  },
  {
    path: PDRL_MARKETING_ROUTES.CRMLEAD_DETAIL,
    element: <LeadsDetail />,
  },
  {
    path: PDRL_MARKETING_ROUTES.CRMLEAD_LOGS,
    element: <AllLeadsCallHistory />,
  },
];

const PDRL_TELE_Caller_COMPONENTS = [
  {
    path: PDRL_Telecaller_ROUTES.TelecallerDashboard,
    element: <TeleCallerDashBoard />,
  },
  {
    path: PDRL_SUCCESS_ENGI_ROUTES.REQUESTDETAILS,
    element: <ViewRequestDetails />,
  },
  {
    path: ROUTES.PROFILE,
    element: <Profile />,
  },
  {
    path: PDRL_ADMIN_ROUTES.REQUESTISSUEDETAIL,
    element: <RequestIssueDetail />,
  },
];

const PDRL_SALES_COMPONENTS = [
  {
    path: PDRL_SALES_ROUTES.SALES_DASHBOARD,
    element: <SalesDashboard />,
  },
  {
    path: PDRL_SALES_ROUTES.SALES_STORES,
    element: <SalesStores />,
  },
  {
    path: PDRL_SALES_ROUTES.SALES_STORES_DETAILS,
    element: <SalesStoreDetails />,
  },
  {
    path: PDRL_SALES_ROUTES.CRMDASHBOARD,
    element: <CrmDashBoard />,
  },
  {
    path: PDRL_SALES_ROUTES.CRMLEADS,
    element: <AllLeads />,
  },
  {
    path: PDRL_SALES_ROUTES.CRMLEAD_DETAIL,
    element: <LeadsDetail />,
  },
  {
    path: PDRL_SALES_ROUTES.CRMLEAD_LOGS,
    element: <AllLeadsCallHistory />,
  },
  {
    path: PDRL_SALES_ROUTES.CRMCAMPAIGN,
    element: <AllCampaign />,
  },
];

const PDRL_ADMIN_ROUTES_COMPONENTS = [
  {
    path: PDRL_ADMIN_ROUTES.ADMIN_DASHBOARD,
    element: <AdminDashBoard />,
  },
  {
    path: PDRL_ADMIN_ROUTES.LOCATIONS,
    element: <Locations />,
  },
  {
    path: PDRL_ADMIN_ROUTES.MANUFACTURES,
    element: <Manufacturers />,
  },
  {
    path: PDRL_ADMIN_ROUTES.CROPS,
    element: <Crops />,
  },
  {
    path: PDRL_ADMIN_ROUTES.TEAMS,
    element: <ManageAdminTeam />,
  },
  {
    path: PDRL_ADMIN_ROUTES.COUPONS,
    element: <AdminCoupons />,
  },
  {
    path: PDRL_ADMIN_ROUTES.VIEWLOCATIONSONMAP,
    element: <ViewLocationsOnMap />,
  },
  {
    path: PDRL_ADMIN_ROUTES.DSPWALLET,
    element: <DspWallet />,
  },
  {
    path: PDRL_ADMIN_ROUTES.SUPPORTEMAILS,
    element: <SupportEmails />,
  },
  {
    path: PDRL_ADMIN_ROUTES.OPEARTIONSDASHBOARD,
    element: <OperationsDashboard />,
  },
  {
    path: PDRL_ADMIN_ROUTES.ALLDRONES,
    element: <Drones />,
  },
  {
    path: PDRL_ADMIN_ROUTES.OPERATIONDSPS,
    element: <OperationsDsps />,
  },
  {
    path: PDRL_ADMIN_ROUTES.OPERATIONSUSERS,
    element: <OperationsUsers />,
  },
  {
    path: PDRL_ADMIN_ROUTES.OPEARTIONSPILOTS,
    element: <OperationsPilots />,
  },
  {
    path: PDRL_ADMIN_ROUTES.VIEWUSERSONMAP,
    element: <ViewUsersOnLocation />,
  },
  {
    path: PDRL_ADMIN_ROUTES.DSPDASHBOARD,
    element: <DspDetails />,
  },
  {
    path: PDRL_ADMIN_ROUTES.REWARDPROGRAM,
    element: <RewardProgram />,
  },
  {
    path: PDRL_ADMIN_ROUTES.DRONESTORE,
    element: <DroneStoreDashboard />,
  },
  {
    path: PDRL_ADMIN_ROUTES.DRONEMODELDETAIL,
    element: <AddDroneModel />,
  },
  {
    path: PDRL_ADMIN_ROUTES.DRONEENQUIRY,
    element: <DroneEnquiries />,
  },
  {
    path: PDRL_ADMIN_ROUTES.DRONESTOREMANUFACTURE,
    element: <DroneManufactures />,
  },
  {
    path: PDRL_ADMIN_ROUTES.DRONEMODELS,
    element: <DroneModels />,
  },
  {
    path: PDRL_ADMIN_ROUTES.REWARDORDERS,
    element: <RewardOrders />,
  },
  {
    path: PDRL_ADMIN_ROUTES.REWARD_PRODUCTS,
    element: <RewardProducts />,
  },
  {
    path: PDRL_ADMIN_ROUTES.STORES,
    element: <Stores />,
  },
  {
    path: PDRL_ADMIN_ROUTES.STOREDETAILS,
    element: <StoresDetailsDashBoard />,
  },
  {
    path: PDRL_ADMIN_ROUTES.CREATEFEED,
    element: <CreateNewFeed />,
  },
  {
    path: PDRL_ADMIN_ROUTES.REQUESTISSUEDASHBOARD,
    element: <RequestIssueDashboard />,
  },
  {
    path: PDRL_ADMIN_ROUTES.BHUMEET_PERFORMANCE,
    element: <BhuMeetPerformance />,
  },
  {
    path: PDRL_ADMIN_ROUTES.REQUESTISSUEDETAIL,
    element: <RequestIssueDetail />,
  },
  {
    path: PDRL_ADMIN_ROUTES.MARKETINGNOTIFICATIONHISTORY,
    element: <MarketingNotificationHistory />,
  },
  {
    path: PDRL_ADMIN_ROUTES.MARKETINGSTATDASHBOARD,
    element: <MarketingStatsDashBoard />,
  },
  {
    path: PDRL_ADMIN_ROUTES.TEXTNOTIFICATIONHISTORY,
    element: <MarketingTextNotificationHistory />,
  },
  {
    path: PDRL_ADMIN_ROUTES.CRMDASHBOARD,
    element: <CrmDashBoard />,
  },
  {
    path: PDRL_ADMIN_ROUTES.CRMLEADS,
    element: <AllLeads />,
  },
  {
    path: PDRL_ADMIN_ROUTES.CRMLEAD_DETAIL,
    element: <LeadsDetail />,
  },
  {
    path: PDRL_ADMIN_ROUTES.CRMLEAD_LOGS,
    element: <AllLeadsCallHistory />,
  },
  {
    path: PDRL_ADMIN_ROUTES.OPERATIONS_LEAD_DETAILS,
    element: <OperationsLeadOrders />,
  },

  ...PDRL_FINANCE_COMPONENTS,
  ...PDRL_SUCCESS_ENGI_COMPONENTS,
  ...PDRL_MARKETING_COMPONENTS,
  ...PDRL_SALES_COMPONENTS,
  ...PDRL_TELE_Caller_COMPONENTS,
  ...PDRL_TELECALLER_SALES_COMPONENTS,
];

const ALL_ROUTES_ARRAY = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: ROUTES.MYSERVICES,
    element: <MyServices />,
  },
  {
    path: ROUTES.MYLOCATIONS,
    element: <MyLocations />,
  },
  {
    path: ROUTES.MYREQUESTS,
    element: <MyRequests />,
  },
  {
    path: ROUTES.REQUESTDETAILS,
    element: <RequestDetails />,
  },
  {
    path: ROUTES.ADD_SERVICE,
    element: <AddService />,
  },
  {
    path: ROUTES.CUSTOMERS,
    element: <UsersList />,
  },
  {
    path: ROUTES.CUSTOMER_DETAILS,
    element: <UserDetails />,
  },
  {
    path: ROUTES.CUSTOMER_FIELDS,
    element: <Fields />,
  },
  {
    path: ROUTES.DRONE_PILOTS,
    element: <DronePilots />,
  },
  {
    path: ROUTES.ADD_DRONE_PILOT,
    element: <AddDronePilot />,
  },
  {
    path: ROUTES.MANAGE_TEAM,
    element: <ManageTeam />,
  },
  {
    path: ROUTES.MYDRONE,
    element: <MyDrones />,
  },
  {
    path: ROUTES.VIEWREQUEST,
    element: <ViewRequest />,
  },
  {
    path: ROUTES.REVENUE,
    element: <Revenue />,
  },
  {
    path: ROUTES.ACREAGE,
    element: <Acreage />,
  },
  {
    path: ROUTES.COUPON,
    element: <AllCoupons />,
  },
  {
    path: ROUTES.CREATEREQUEST,
    element: <CreateRequest />,
  },
  {
    path: ROUTES.WALLET,
    element: <MyWallet />,
  },
  {
    path: ROUTES.PAYMENTINVOICE,
    element: <DspInvoiceDetails />,
  },
  {
    path: ROUTES.REQUESTSOVERVIEW,
    element: <RequestsOverView />,
  },
  {
    path: ROUTES.INCENTIVESOVERVIEW,
    element: <IncentiveOverView />,
  },
  {
    path: ROUTES.INCENTIVES,
    element: <DspIncentives />,
  },
  {
    path: ROUTES.BESREQUESTSOVERVIEW,
    element: <BesRequestsOverView />,
  },
  {
    path: ROUTES.SUBSCRIPTION_PLANS,
    element: <SubscriptionPlans />,
  },
  {
    path: ROUTES.LEADINVOICEDETAILS,
    element: <DspLeadInvoiceDetails />,
  },
  {
    path: ROUTES.SUBSCRIPTION_INVOICE_DETAILS,
    element: <DspSubscriptionInvoiceDetails />,
  },
  {
    path: ROUTES.REPORTS,
    element: <Reports />,
  },
  {
    path: ROUTES.PILOTS_PERFORMANCE_REPORT,
    element: <PilotsPerformanceReport />,
  },
  {
    path: ROUTES.ORDERS_PERFORMANCE_REPORT,
    element: <OrderPerformanceReport />,
  },
];

export {
  ROUTES,
  ALL_ROUTES_ARRAY,
  PDRL_ADMIN_ROUTES,
  PDRL_SUCCESS_ENGI_ROUTES,
  PDRL_ADMIN_ROUTES_COMPONENTS,
  PDRL_SUCCESS_ENGI_COMPONENTS,
  PDRL_MARKETING_COMPONENTS,
  PDRL_FINANCE_COMPONENTS,
  PDRL_FINANCE_ROUTES,
  PDRL_MARKETING_ROUTES,
  PDRL_SALES_ROUTES,
  PDRL_SALES_COMPONENTS,
  PDRL_TELE_Caller_COMPONENTS,
  PDRL_Telecaller_ROUTES,
  PDRL_TELECALLER_SALES_COMPONENTS,
  PDRL_TELECALLER_SALES_ROUTES,
};
